import React, {Component} from "react";
import withAuthorization from "../../services/Authorization";
import {FormattedMessage} from "react-intl";
import MessageConfiguration from "./MessageConfiguration";
import BannerConfiguration from "./BannerConfiguration";
import BackgroundConfiguration from "./BackgroundConfiguration";
import Storage from "../../services/Storage";

class Communication extends Component {


  render() {
    const user = Storage.getItem('user');
    const isNsc = user.role === 'NSC_ADMIN';

    return (
      <div>
        <header className="main-header">
          <h1 className="main__title">
            <FormattedMessage id="page.communication" />
          </h1>
        </header>

        <div className="main__content">
          <MessageConfiguration />
          {isNsc && <BackgroundConfiguration />}
          {isNsc && <BannerConfiguration />}
        </div>
      </div>
    )
  }
}

export default withAuthorization(Communication, ['DUI_ADMIN', 'NSC_ADMIN']);



// WEBPACK FOOTER //
// ./src/components/communication/Communication.js